$(function () {
	const $containers = $('[data-collapsible-product-table]');
	if (!$containers.length) return;

	$containers.each(function () {
		const $container = $(this);
		let isMobile = window.innerWidth < 768;

		function update(expanded) {
			const table = $container.find('[data-collapsible-products]')[0];
			const footer = $container.find('[data-collapsible-products-footer]')[0];
			const toggle = $container.find('[data-collapsible-products-toggle]')[0];
			if (!table || !footer || !toggle) return;

			const rows = Array.from(table.tBodies[0].rows);
			const visibleCount = isMobile ? 4 : 8;
			// Выбранный размер нельзя прятать вместе с остальными строками таблицы.
			const hiddenRows = rows.filter((row, index) => index >= visibleCount && !row.classList.contains('is-current'));
			const hasMore = hiddenRows.length > 0;
			const showAll = hasMore && expanded;

			rows.forEach((row, index) => {
				row.hidden = hasMore && !showAll && index >= visibleCount && !row.classList.contains('is-current');
			});

			footer.hidden = !hasMore;
			toggle.setAttribute('aria-expanded', String(showAll));
			toggle.querySelector('span').textContent = showAll ? 'Свернуть список' : 'Показать все размеры';
		}

		$container.on('click', '[data-collapsible-products-toggle]', function () {
			update(this.getAttribute('aria-expanded') !== 'true');
		});

		$container.on('serie-table-updated', function () {
			update(false);
		});

		$(window).on('resize', function () {
			const nextIsMobile = window.innerWidth < 768;
			if (nextIsMobile === isMobile) return;

			isMobile = nextIsMobile;
			const toggle = $container.find('[data-collapsible-products-toggle]')[0];
			update(toggle && toggle.getAttribute('aria-expanded') === 'true');
		});

		update(false);
	});
});
